import { useAuth } from '../contexts/AuthContext';

/**
 * Convenience hooks for permission-gated UI.
 *
 *   const canManageAccounts = usePermission('accounts.manage');
 *   const isAdmin = useRole('admin');
 *
 * Use these to conditionally render buttons, menu items, etc.
 */

export function usePermission(...codes) {
  const { hasPermission } = useAuth();
  return hasPermission(...codes);
}

export function useRole(...roles) {
  const { hasRole } = useAuth();
  return hasRole(...roles);
}
